import { createSelector } from 'reselect'

import { RootState } from '../../types'

export const selectState = createSelector(
  (s: RootState) => s.profileManagement,
  b => b
)

export const selectConfig = createSelector(
  (state: RootState) => state.config,
  c => c
)

export const areInvitedUsersLoading = createSelector(selectState, s => s.loading)

export const getInvitedUsers = createSelector(selectState, s => s.records)

export const getInvitedUsersPageSize = createSelector(selectConfig, c => c.pageSizes['profileManagement'] || 10)

export const getProfileManagementFilters = createSelector(selectState, s => s.filters)

export const getProfileManagementSearchFilter = createSelector(selectState, s => s.searchFilter)

export const isFilterActive = createSelector(
  getProfileManagementFilters,
  filters => Object.keys(filters || {}).length > 0
)

export const isSearchFilterActive = createSelector(getProfileManagementSearchFilter, search => !!search)

export const isFilteringActive = createSelector(
  isFilterActive,
  isSearchFilterActive,
  (isFilter, isSearchFilter) => isFilter || isSearchFilter
)

export const hasAnyUnfilteredInvitedUsers = createSelector(
  isFilteringActive,
  getInvitedUsers,
  (isFiltering, invitedUsers) => isFiltering || !!(invitedUsers?.length ?? false)
)
